<template>
  <div>
    <b-modal
      id="areYouShureRemovingDay"
      modal-class="modal-cover"
      v-model="isVisible"
      hide-backdrop
      hide-footer
      content-class="shadow-lg modal-lg"
      centered
    >
      <section class="text-center" :dir="isHebrew ? 'rtl' : 'ltr'">
        <b-row>
          <b-col cols="12" class="py-4">
            <h3 class="font-weight-bold title-text">
              {{ t('removeDayTitle') }}
            </h3>
          </b-col>

          <b-col cols="12" class="py-3">
            <p class="message-text">
              {{ t('removeDayMessage') }}
            </p>
          </b-col>

          <b-col cols="12" class="py-4">
            <b-btn
              pill
              variant="danger"
              class="action-button mb-3"
              @click="removeDayAndAttractions"
            >{{ t('removeDayAndAttractionsButton') }}</b-btn>

            <b-btn
              pill
              variant="warning"
              class="action-button mb-3"
              @click="removeDayOnly"
            >{{ t('removeDayOnlyButton') }}</b-btn>

            <b-btn
              pill
              variant="secondary"
              class="action-button"
              @click="closePopup"
            >{{ t('removeDayCancelButton') }}</b-btn>
          </b-col>
        </b-row>
      </section>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { translationMixin } from '@/mixins/translationMixin';

export default {
  props: ["value"],
  mixins: [translationMixin],
  computed: {
    ...mapGetters(["inerModalParameters"]),
    isVisible: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    ...mapActions([
      "removeDayFromRide",
      "removeDayAndAttractionsFromRide",
      "showModal",
      "showModalWithParameters",
    ]),
    async removeDayOnly() {
      const dayIndex = this.inerModalParameters.dayIndex;
      this.showModal("loadingIcon");
      const success = await this.removeDayFromRide( { dayIndex } );
      
      // Only show success message if the operation succeeded
      if (success) {
        this.showModalWithParameters({
          errorNumber: "the_day_wewre_delited_and_the_activites_pushed_to_the_next_day",
          type: "textConverter",
        });
      }
    },
    async removeDayAndAttractions() {
      const dayIndex = this.inerModalParameters.dayIndex;
      this.showModal("loadingIcon");
      const success = await this.removeDayAndAttractionsFromRide( { dayIndex } );
      
      // Only show success message if the operation succeeded
      if (success) {
        this.showModalWithParameters({
          errorNumber: "the_day_and_its_activities_were_deleted",
          type: "textConverter",
        });
      }
    },
    closePopup() {
      this.showModal("");
    },
  },
};
</script>

<style scoped>
.modal.modal-cover .modal-content,
.modal.modal-cover .modal-footer,
.modal.modal-cover .modal-header {
  border: none;
}

.title-text {
  font-size: 24px;
  color: #2E2E3A;
  margin-bottom: 20px;
}

.message-text {
  font-size: 18px;
  color: #2E2E3A;
  line-height: 1.5;
  margin: 0 auto;
  max-width: 80%;
}

.action-button {
  font-size: 18px;
  padding: 15px 30px;
  width: 80%;
  max-width: 500px;
  display: block;
  margin: 0 auto;
}

.action-button:hover {
  transform: translateY(-2px);
  transition: transform 0.2s ease;
}

.modal-lg {
  max-width: 600px;
}
</style> 